import { Flex } from "@similarweb/ui-components/foundations";

import { AccountSignalsGuideLink } from "../AccountSignalsGuideLink/AccountSignalsGuideLink";
import { SuggestSignalsFromDealsChip } from "../SuggestSignalsFromDealsChip/SuggestSignalsFromDealsChip";

export const AccountSignalsPageHeaderActions = () => (
    <Flex
        position="absolute"
        top={0}
        right={0}
        alignItems="center"
        gap="8px"
    >
        <AccountSignalsGuideLink />
        <SuggestSignalsFromDealsChip />
    </Flex>
);
